import React, { useState, useEffect } from 'react';
import { Col, Row, Card, Button, Modal } from 'react-bootstrap';
import DrupalFieldItem from './DrupalFieldItem';
import SocialMediaIcon from './SocialMeidaIcon';
import ReactStars from 'react-rating-stars-component';
import ReviewsDisplay from './ReviewsDisplay';
import { CONFIG } from '../utils/config';
import IconClose from '../images/icon_close.png';

const CardItem = props => {
  const { viewStyle, postcodeSearch, categoryTerms, ageTerms, hasClose } = props;
  const [show, setShow] = useState(false);
  const [orgIdShow, setOrgIdShow] = useState();
  const [orgTitle, setOrgTitle] = useState();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const {
    drupal_internal__nid,
    title,
    distance,
    field_telephone,
    field_description,
    field_address,
    field_contact_name,
    field_avg_rating,
    field_website,
    field_email,
    field_social_media,
  } = props.data.attributes;

  const orgId = props.data.id;

  const { field_industry, field_age_range } = props.data.relationships;

  const address_line1 = field_address?.address_line1
    ? field_address.address_line1 + ', '
    : '';
  const address_line2 = field_address?.address_line2
    ? field_address.address_line2 + ', '
    : '';
  const city = field_address?.locality ? field_address.locality + ', ' : '';
  const postcode = field_address?.postal_code ? field_address.postal_code : '';

  const address = address_line1 + address_line2 + city + postcode;

  const [logoPath, setLogoPath] = useState();

  const OrgModal = props => {
    return (
      <>
        <Modal show={show} onHide={handleClose} className="ratingModal">
          <Modal.Header closeButton>
            <Modal.Title>Reviews for {orgTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ReviewsDisplay orgId={orgIdShow} />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  useEffect(() => {
    const getData = async () => {
      const response = await fetch(
        `${CONFIG.API_URL}${CONFIG.ORG_LOGO}` + '/' + drupal_internal__nid,
      );
      const logo = await response.json();
      const logoUrl = `${CONFIG.API_URL}` + logo[0].thumbnail__target_id;
      if (logo) {
        setLogoPath(logoUrl);
      } else {
        setLogoPath(false);
      }
    };

    getData();
  }, [drupal_internal__nid]);

  // terms
  const [cardCategoryTerms, setCardCategoryTerms] = useState([])
  const [cardAgeTerms, setCardAgeTerms] = useState([])

  const getTerms = (allTerms, field, setMethod) => {
    const cardTermIds = Array.isArray(field.data) ? field.data.map(item => item.id) : field.data.id;
    const filteredTerms = allTerms.filter(item => cardTermIds.includes(item.id));
    const filteredTermsNames = filteredTerms.map(item => item.attributes.name);

    setMethod(filteredTermsNames);
  }

  useEffect(() => {
    if ((categoryTerms && categoryTerms.length > 0) && (ageTerms && ageTerms.length > 0)) {
      getTerms(categoryTerms, field_industry, setCardCategoryTerms)
      getTerms(ageTerms, field_age_range, setCardAgeTerms)
    }
  }, [categoryTerms, ageTerms])

  if (viewStyle && viewStyle === 'list') {
    return (
      <>
        <OrgModal/>
        <div className="card list-card col-12 col-md-12 col-lg-12 m-0 my-2 p-0">
          <div className="inner h-100 p-0">

            <Row className="mx-0">
              <Col className="col-3 m-0 p-0 img-col">
                <Row className="mx-0 pt-1">
                  <div className="col">
                    <div className="list-card-img">
                      {logoPath && <img src={logoPath} alt={title} className="img-fluid"/>}
                    </div>
                  </div>
                  <div className="col-1 mt-1 mr-1">
                    <div className="social-icons row">
                      {field_social_media?.platform_values?.twitter?.value?.length > 0 && (
                        <SocialMediaIcon
                          icon="twitter"
                          platform="twitter.com"
                          value={field_social_media?.platform_values?.twitter?.value}
                        />
                      )}
                      {field_social_media?.platform_values?.facebook?.value?.length > 0 && (
                        <SocialMediaIcon
                          icon="facebook"
                          platform="facebook.com"
                          value={field_social_media?.platform_values?.facebook?.value}
                        />
                      )}
                      {field_social_media?.platform_values?.instagram?.value?.length > 0 && (
                        <SocialMediaIcon
                          icon="instagram"
                          platform="instagram.com"
                          value={field_social_media?.platform_values?.instagram?.value}
                        />
                      )}
                      {field_social_media?.platform_values?.youtube?.value?.length > 0 && (
                        <SocialMediaIcon
                          icon="youtube"
                          platform="youtube.com"
                          value={field_social_media?.platform_values?.youtube?.value}
                        />
                      )}
                    </div>
                  </div>
                </Row>
              </Col>
              <Col className="col-9 content-col mx-0 px-0">
                <Row className="ml-0 mr-0">

                  <Col className="col-4">
                    <div className=" m-0 mb-2 p-2">
                      <h3 className="fw-800">{title}</h3>
                      <DrupalFieldItem label="Contact" value={field_contact_name}/>
                    </div>
                  </Col>

                  <Col className="col-4 pl-0">
                    <div
                      className=" m-0 mb-2 p-2"
                      dangerouslySetInnerHTML={{__html: field_description.value}}
                    />
                  </Col>

                  <Col className="col-4 pl-0">
                    <div className=" m-0 mb-2 p-2">
                      {cardAgeTerms.length > 0 && (
                        <DrupalFieldItem
                          label="Age range"
                          value={cardAgeTerms.length === ageTerms.length ? 'All ages' : cardAgeTerms.join(', ')}
                        />
                      )}
                      {address && (
                        <DrupalFieldItem label="Address" value={address}/>
                      )}
                      {field_telephone && (
                        <DrupalFieldItem label="Telephone" value={field_telephone}/>
                      )}
                      {field_email && (
                        <DrupalFieldItem label="Email" value={field_email} link={true}/>
                      )}

                      {cardCategoryTerms.length > 0 && (
                        <DrupalFieldItem label="Category" value={cardCategoryTerms.join(', ')}/>
                      )}
                      {postcodeSearch && distance && (
                        <DrupalFieldItem
                          label="Distance (as the crow flies)"
                          value={`${parseFloat(distance * 0.000621371192).toFixed(1)} miles`}
                        />
                      )}

                      <CardRating rating={field_avg_rating} />
                    </div>
                  </Col>
                </Row>
                <Row className="card-footer mt-1">

                  {field_website ? (
                    <Col className="col-6 p-0 m-0">
                      <a
                        className="btn btn-primary website-btn"
                        target="_blank"
                        rel="noreferrer"
                        href={field_website}
                      >
                        Visit website
                      </a>
                    </Col>
                  ) : (
                    <Col className="col-6 p-0 m-0">&nbsp;</Col>
                  )}
                  <Col className="col-6 p-0 m-0">

                  <Button
                    className="ratings-btn"
                    onClick={() => {
                      handleShow();
                      setOrgIdShow(orgId);
                      setOrgTitle(title);
                    }}
                  >
                    View reviews
                  </Button>
                  </Col>

                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </>
    )
  } else {
    return (
      <>
        <OrgModal/>
        <Card className="col-12 col-md-6 col-lg-4 m-0 mb-2 p-2">
          {hasClose && (
            <div className="map-info-close" onClick={props.closeCard}><img src={IconClose} alt="close"/></div>
          )}
          <div className="inner h-100 p-0">
            <Card.Header>
              <Row>
                <div className="col">
                  <div className="image-card">
                    {logoPath && <img src={logoPath} className="img-fluid"/>}
                  </div>
                </div>
                <div className="col-1">
                  <div className="social-icons row">
                    {field_social_media?.platform_values?.twitter?.value?.length > 0 && (
                      <SocialMediaIcon
                        icon="twitter"
                        platform="twitter.com"
                        value={field_social_media?.platform_values?.twitter?.value}
                      />
                    )}
                    {field_social_media?.platform_values?.facebook?.value?.length > 0 && (
                      <SocialMediaIcon
                        icon="facebook"
                        platform="facebook.com"
                        value={field_social_media?.platform_values?.facebook?.value}
                      />
                    )}
                    {field_social_media?.platform_values?.instagram?.value?.length > 0 && (
                      <SocialMediaIcon
                        icon="instagram"
                        platform="instagram.com"
                        value={field_social_media?.platform_values?.instagram?.value}
                      />
                    )}
                    {field_social_media?.platform_values?.youtube?.value?.length > 0 && (
                      <SocialMediaIcon
                        icon="youtube"
                        platform="youtube.com"
                        value={field_social_media?.platform_values?.youtube?.value}
                      />
                    )}
                  </div>
                </div>
              </Row>
            </Card.Header>
            <Card.Title className="fw-800 pt-4 pl-3 pr-4 pb-0">{title}</Card.Title>
            <Card.Body className="pl-3 pt-0">
              <div
                className="content fw-400 mb-2"
                dangerouslySetInnerHTML={{__html: field_description.value}}
              />
              <div className="info row">
                <div className="col-7">
                  <DrupalFieldItem label="Contact" value={field_contact_name}/>
                </div>
                <div className="col-5">
                  {cardAgeTerms.length > 0 && (
                    <DrupalFieldItem label="Age range"
                                     value={cardAgeTerms.length === ageTerms.length ? 'All ages' : cardAgeTerms.join(', ')}/>
                  )}
                </div>
              </div>
              <div className="info row">
                <div className="col-12">
                  <DrupalFieldItem label="Address" value={address}/>
                  <DrupalFieldItem label="Telephone" value={field_telephone}/>
                </div>
              </div>

              <DrupalFieldItem
                label="Email"
                value={field_email}
                link={true}
              />

              <div className="info row">
                {cardCategoryTerms.length > 0 && (
                  <div className="col-7">
                    <DrupalFieldItem label="Category" value={cardCategoryTerms.join(', ')}/>
                  </div>
                )}

                <div className="col-5 ">
                  <CardRating rating={field_avg_rating} />
                </div>
              </div>

              {postcodeSearch && distance && (
                <DrupalFieldItem
                  label="Distance (as the crow flies)"
                  value={`${parseFloat(distance * 0.000621371192).toFixed(1)} miles`}
                />
              )}
            </Card.Body>

            <Card.Footer className="pt-0 pb-0">
              <Row className="p-0 m-0">
                {field_website && (
                  <Col className="p-0 m-0">
                    <a
                      className="btn btn-primary website-btn"
                      target="_blank"
                      rel="noreferrer"
                      href={field_website}
                    >
                      Visit website
                    </a>
                  </Col>
                )}
                <Col className="p-0">
                  <Button
                    className="ratings-btn"
                    onClick={() => {
                      handleShow();
                      setOrgIdShow(orgId);
                      setOrgTitle(title);
                    }}
                  >
                    View reviews
                  </Button>
                </Col>
              </Row>
            </Card.Footer>
          </div>
        </Card>
      </>
    )
  }
};

export default CardItem;

const CardRating = props => {
  const { rating } = props;

  return (
    <>
      {rating ? (
        <div className="field-item-row">
          <label className="w-100">Avg. rating</label>
          <ul className="field-value font-bold card-stars" aria-label={`Average rating: ${rating} stars`}>
            <ReactStars
              name="rating"
              count={5}
              value={rating}
              size={20}
              edit={false}
              activeColor="#3F2B56"
              color="#fff"
            />
          </ul>
        </div>
      ) : (
        <DrupalFieldItem label="Avg. rating" value="Not yet reviewed" />
      )}
    </>
  )
}
